module.exports = __webpack_public_path__ + "src/assets/img/rampantcrime.c08a34d0.jpg";